export const isClipboardSupported = (): boolean => {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return false
    }
    const clipboardSupported = !!(
        navigator.clipboard && typeof navigator.clipboard.write === 'function'
    )
    const clipboardItemSupported = typeof window.ClipboardItem === 'function'

    return clipboardSupported && clipboardItemSupported
}

export const createClipboardItem = (
    htmlContent: string,
    plainTextContent: string,
): ClipboardItem => {
    return new ClipboardItem({
        'text/html': new Blob([htmlContent], { type: 'text/html' }),
        'text/plain': new Blob([plainTextContent], { type: 'text/plain' }),
    })
}

export const copyToClipboard = async (
    htmlContent: string,
    plainTextContent: string,
): Promise<boolean> => {
    if (!isClipboardSupported()) {
        return false
    }
    const clipboardItem = createClipboardItem(htmlContent, plainTextContent)
    await navigator.clipboard.write([clipboardItem])
    return true
}
